<template>
  <vs-popup
    id="PopupHowToWrite"
    title="환경영향평가서 작성방법"
    :active.sync="showPopup"
  >
    <div class="p-2" style="border: 1px solid #cdcdcd;">
      <!-- top -->
      <div>
        <p>평가담당자는 환경영향평가서를 이용하여 사용물질 및 배출물질을 대상으로 환경영향이 예상되는 항목에 대해 계수화하여 환경영향에 대한 중요도를 등급화하고 환경영향을 평가한다.</p>
        <h5 class="py-4">가. 작성방법</h5>
        <p>(1) 공정 : 공장에서 일어나는 활동(공정포함) 제품 및 서비스에 대해 환경측면과 그 환경영향을 작성한다.</p>
        <p>(2) 사용물질 : 해당부서의 활동(공정)에서 사용 또는 보관되는 모든 물질을 파악하여 기록하고 이때 공정에 직접 사용되는 원, 부자재, 원료, 연료, 에너지는 물론 간접적으로 사용되는 소모품, 사무용품, 저장품 등을 포함하여야 한다. 그리고 정상, 비정상, 비상상태에 따라 사용물질이 상이한 경우는 이를 명확히 파악하여 기록하여야 한다.</p>
        <p>(3) 사용량 : 사용(인입)되는 물질의 평균사용량을 단위기간별로 기록한다.</p>
        <p>(4) 상태 : 정상, 비정상, 비상상태로 구분하여 기록하고 비정상이나 비상상태가 없으면 기록하지 않는다.</p>
        <p>(5) 세부공정/활동 : 해당부서의 활동 또는 공정에 대하여 발생 형태에 따라 정상, 비정상, 비상상태별로 환경측면의 세부적인 상황 및 현상(상태)를 작성한다. (예 : Leak, 화학세정...등)</p>
        <p>(6) 배출물질 : 활동이나 공정에 투입 또는 사용 후 발생되는 모든 물질로서 제품 반제품을 포함한 부산물, 폐기물, 폐가스(대기), 폐수, 소음/진동, 악취, 분진 등 배출물질의 형태를 파악하여 기록한다. (비정상상태와 비상상태의 경우도 작성되어야 한다.)</p>
        <p>(7) 배출량 : 배출물질의 평균 배출량을 단위기간별로 기록한다. 실측이 불가능할 경우 수학적 이론에 의한 계산치를 사용할 수 있으며, 배출물질의 형태 및 양의 예측이 불가능할 경우 기록하지 않아도 된다.</p>
        <p>(8) 환경요소 : 파악된 환경측면에 의한 환경영향을 미치는 환경요소를 파악하여 환경영향 평가기궂ㄴ에 따라 영향도를 평가하여 기록한다.</p>
        <p>(9) 심각도 : 환경요소(대기, 소음진동, 수질, 폐기물, 토양, 에너지, 천연자원, 생태계)들의 점수의 합으로 자동계산</p>
        <p>(10) 검출도 : 환경영향이 감지 및 통제관리 되는 체계를 평가한다. (Yes 1개이하 : 3점, Yes 2~3개 : 2점, Yes 4개 : 1점)</p>
        <p>(11) 확률 : 환경사고의 발생 가능성을 평가하며 아래 항목 체크 시 점수가 자동 부여된다. </p>
      </div>

      <!-- 검출도 -->
      <div class="mt-7">
        <div class="mb-4">
          <div class="flex flex-wrap items-center justify-start gap-3">
            <h5><i class="dot"></i>검출도</h5>
            <div class="ml-auto"></div>
          </div>
        </div>

        <table>
          <colgroup>
            <col width="313"/>
            <col width="110"/>
            <col width="155"/>
          </colgroup>
          <tr>
            <th>평가기준</th>
            <th>평가</th>
            <th>비고</th>
          </tr>
          <tr v-for="(검출도, index) in form.검출도" :key="`검출도_${index}`">
            <td>{{ 검출도.title }}</td>
            <td>
              <div class="flex justify-center">
                <radio-group flex v-model="검출도.평가" :items="[{label: 'Yes', value: 1}, {label: 'No', value: 0}]"/>
              </div>
            </td>
            <td><ml-input v-model="검출도.비고" /></td>
          </tr>
        </table>
      </div>

      <!-- 확률 -->
      <div class="mt-7">
        <div class="mb-4">
          <div class="flex flex-wrap items-center justify-start gap-3">
            <h5><i class="dot"></i>확률</h5>
            <div class="ml-auto"></div>
          </div>
        </div>

        <table class="w-full">
          <colgroup>
            <col width="468"/>
            <col width="110"/>
          </colgroup>
          <tr>
            <th>평가기준</th>
            <th>평가</th>
          </tr>
          <tr v-for="(확률, index) in form.확률" :key="`검출도_${index}`">
            <td class="py-4">{{ 확률.title }}</td>
            <td>
              <div class="grid justify-center">
                <vs-checkbox v-model="확률.평가" >Yes({{ 확률.점수 }}점)</vs-checkbox>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <!-- (12) -->
      <div class="mt-4">
        <p>(12) 발생 가능성 : 아래 메트릭스 표에 의한 방법으로 자동 계산된다.</p>
        <div class="mb-4">
          <div class="flex flex-wrap items-center justify-start gap-3">
            <h5>발생 가능성 점수 산정</h5>
          </div>
        </div>
        <table>
          <tr>
            <th rowspan="2" colspan="2">평가기준</th>
            <th colspan="3">평가</th>
          </tr>
          <tr>
            <th>1</th>
            <th>2</th>
            <th>3</th>
          </tr>
          <tr>
            <th rowspan="3">평가</th>
            <th>1</th>
            <td class="text-center" style="font-weight: 500">1</td>
            <td class="text-center" style="font-weight: 500">2</td>
            <td class="text-center" style="font-weight: 500">3</td>
          </tr>
          <tr>
            <th>2</th>
            <td class="text-center" style="font-weight: 500">2</td>
            <td class="text-center" style="font-weight: 500">4</td>
            <td class="text-center" style="font-weight: 500">4</td>
          </tr>
          <tr>
            <th>3</th>
            <td class="text-center" style="font-weight: 500">3</td>
            <td class="text-center" style="font-weight: 500">4</td>
            <td class="text-center" style="font-weight: 500">5</td>
          </tr>
        </table>
      </div>

      <!-- (13) -->
      <div class="mt-4">
        <p>(13) 중요도 : 심각도와 발생 가능성의 곱으로 등급 산정은 아래표에 의해 자동 연산된다.</p>
        <table>
          <tr>
            <th>점수</th>
            <th>점수구분</th>
          </tr>
          <tr>
            <td class="text-center" style="font-weight: 500">H(High)</td>
            <td class="text-center" style="font-weight: 500">25점이상</td>
          </tr>
          <tr>
            <td class="text-center" style="font-weight: 500">M(Middle)</td>
            <td class="text-center" style="font-weight: 500">15점이상 25점미만</td>
          </tr>
          <tr>
            <td class="text-center" style="font-weight: 500">L(Low)</td>
            <td class="text-center" style="font-weight: 500">5점이상 15점미만</td>
          </tr>
          <tr>
            <td class="text-center" style="font-weight: 500">N(None)</td>
            <td class="text-center" style="font-weight: 500">5점미만</td>
          </tr>
        </table>
      </div>

      <!-- 나. 환경영향 식별 기준 -->
      <div class="mt-7">
        <div class="mb-4">
          <div class="flex flex-wrap items-center justify-start gap-3">
            <h5>나. 환경영향 식별 기준</h5>
          </div>
        </div>
        <p>식별된 환경측면 중에서 점수가 높은 환경요소를 선정하여 표기<br>
          예) 환경요소 : 대기 3점, 수질 2점, 폐기물 1점 중에서 환경영향은 [대기영향]으로 표기</p>
      </div>

    </div>
  </vs-popup>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";

export default {
  name: 'PopupHowToWrite',
  components: {RadioGroup},
  props: {
    value: Boolean,
  },
  computed: {
    showPopup: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    },
  },
  data() {
    return {
      form: {
        검출도: [
          { 'title': '- 환경사고를 방지할 수 있는 관리방법 또는 예방시설/대책이 설정되어 있다.' , '평가': 1, '비고': '' },
          { 'title': '- 정기적인 점검 및 모니터가 되고 있다.' , '평가': 1, '비고': '' },
          { 'title': '- 정기적으로 관련자에게 교육훈련이 실시되고 있다.' , '평가': 1, '비고': '' },
          { 'title': '- 비상사태를 대비한 비상대응 절차가 수립되어 있다.' , '평가': 1, '비고': '' },
        ],

        // 점수 - check 했을 시 (평가 = true 인 경우) 받을 수 있는 점수
        확률: [
          { 'title': '- 정기적으로 관련자에게 교육훈련이 실시되고 있다.' , '평가': true, '점수': 3, '비고': '' },
          { 'title': '- 과거에 환경사고는 없었으나 발생 가능성이 있다.' , '평가': true,'점수': 2, '비고': '' },
          { 'title': '- 발생 가능성이 없다.' , '평가': true, '점수': 1, '비고': '' },
        ],
      },
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
#PopupHowToWrite::v-deep {
  .vs-popup {
    width: 1167px;
    max-width: 95%;
  }
}

p {
  padding-top: 10px;
  padding-bottom: 10px;

  &:hover {
    background-color: #f9f9f9;
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-top:1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;

  thead {  z-index: 0 !important; }
  th {
    background: #f9f9f9;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;

    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 16px 0;
    text-align: center;
  }
  td {
    background: #fff !important;
    border-right: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    padding: 6px;
  }
}
</style>
